/**
 * Utility to convert Frappe relative file paths to absolute URLs
 * 
 * Use this for APIs that return relative paths (e.g., attachments, other doctypes)
 * Note: Doc Sidebar API already returns absolute URLs, so this is for other use cases
 */

import { useAuthStore } from "@/lib/store/authStore";

export const useFrappeFileUrl = () => {
  const frappeUrl = useAuthStore((s) => s.frappeUrl);

  return (path?: string | null): string | null => {
    if (!path) return null;

    // Already absolute URL
    if (path.startsWith("http://") || path.startsWith("https://")) {
      return path;
    }

    if (!frappeUrl) return path;

    const base = frappeUrl.replace(/\/$/, "");
    const normalized = path.startsWith("/") ? path : `/${path}`;
    return `${base}${normalized}`;
  };
};

